export class DateUtil {

    static convertStartDateStringToUTCString(dateString: string): string {
        let startDate = new Date(dateString)
        startDate.setHours(0,0,1)
        startDate = new Date(new Date(startDate).getTime() + (new Date().getTimezoneOffset() * 60 * 1000))
        return this.toISOStringWithTimeZone(startDate)
    }

    static convertEndDateStringToUTCString(dateString: string): string {
        let endDate = new Date(dateString)
        endDate.setHours(23,59,59)
        endDate = new Date(endDate.getTime() + (new Date().getTimezoneOffset() * 60 * 1000))
        return this.toISOStringWithTimeZone(endDate)
    }

    static convertCurrentDateStringToUTCString(dateString: string): string {
        let endDate = new Date(dateString)
        endDate = new Date(new Date(endDate).getTime() + (new Date().getTimezoneOffset() * 60 * 1000))
        return this.toISOStringWithTimeZone(endDate)
    }

    static toISOString(date: Date): string {

        var pad = function(num: number) {
            return (num < 10 ? '0' : '') + num;
        };

        return date.getFullYear() +
            '-' + pad(date.getMonth() + 1) +
            '-' + pad(date.getDate()) +
            'T' + pad(date.getHours()) +
            ':' + pad(date.getMinutes()) +
            ':' + pad(date.getSeconds())
    }

    static toISOStringWithTimeZone(date: Date): string {
        return this.toISOString(date) + 'Z'
    }
}